import * as React from 'react';

interface ILoaderProps {
	loading?: boolean;
	message?: string;
}

export const Loader: React.FC<ILoaderProps> = ({ loading, message } = { loading: true }) => {

	return (!loading ? null :
		<div className="loading-block">
			<span className="loading-spinner"> </span>
			<div className="loading-text">{message}</div>
		</div>);
};
